import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { em } from 'polished';
import { appTheme } from '../../theme';
import { FacebookLogin } from 'react-facebook-login-component';
import FacebookIcon from '../../img/facebook-icon.png';

const brandBlue = 'rgb(66, 103, 178)';
const brandWhite = 'rgb(255, 255, 255)';
const fontFamily = 'Helvetica, Arial, sans-serif';

const Button = styled(FacebookLogin)`
  align-items: center;
  background-color: ${brandBlue};
  border-radius: ${em('4px', '13px')};
  color: ${brandWhite};
  display: flex;
  font-family: ${fontFamily};
  font-size: ${em('13px')};
  letter-spacing: ${em('.25px', '13px')};
  max-width: ${appTheme.sizing.socialButtonWidth};
  padding: 0 ${em('8px', '13px')} 0 0;
`;

const FacebookLogo = styled.img`
  height: ${em('16px', '13px')};
  margin: ${em('6px', '13px')};
`;

function FacebookLoginButton({ onClick, socialId }) {
  return (
    <Button
      buttonText="Log in With Facebook"
      className="fb-login"
      fields="id,email,name"
      language="en_US"
      responseHandler={onClick}
      scope="public_profile,email"
      socialId={socialId}
      version="v2.5"
      xfbml={true}
    >
      <FacebookLogo alt="Facebook logo" src={FacebookIcon} />
    </Button>
  );
}

FacebookLoginButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  socialId: PropTypes.string.isRequired,
};

export default FacebookLoginButton;



// WEBPACK FOOTER //
// ./src/modules/common/FacebookLoginButton.js